
import Markdown from "../../../Common/components/Markdown";
import markdownComponents from "../../util/markdownComponents";

function Body({ text }) {
  return <Markdown markdown={text} components={markdownComponents} />;
}

export default Body;
